<template>
  <div>
    <List
      url="device-monitor/template-item/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="margin-bottom:30px;">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <el-button @click="openDeviceMonitorTemplateTypes" type="primary" size="small">管理监控模板</el-button>
            <el-button @click="openDeviceMonitorMetrics" type="primary" size="small">管理监控指标</el-button>
            <el-button @click="addTemplateType" type="primary" size="small" icon="el-icon-edit">新增模板类型</el-button>
            <el-button @click="addDeviceMetric" type="primary" size="small" icon="el-icon-edit">新增指标类型</el-button>
            <el-button @click="add" type="primary" size="small" icon="el-icon-edit">新增监控命令</el-button>
          </el-col>

          <el-col :span="24" style="margin-left:10px;">
            <label>选择监控模板：</label>
            <el-select v-model="selectTemplateType"
              @change="search"
              placeholder="选择监控模板" style="width:240px;margin-right:10px;" size="small">
              <el-option
                v-for="monitorTemplateType in MonitorTemplateTypeList"
                :label="monitorTemplateType"
                :key="monitorTemplateType"
                :value="monitorTemplateType"></el-option>
            </el-select>

            <label>监控项状态: </label>
            <el-select v-model="selectStatus" placeholder="监控项是否启用" @change="search" style="width:100px;margin-right:10px;" size="small">
              <el-option value="全部" label="全部"></el-option>
              <el-option
                v-for="status in switchStatus"
                :label="status"
                :key="status"
                :value="status"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-input
          v-model="searchData.metric_name"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入指标名称"
          @change="search"
        ></el-input>

        <el-input
          v-model="searchData.metric_key"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入指标key"
          @change="search"
        ></el-input>

        <el-input
          v-model="searchData.cmd"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入监控命令"
          @change="search"
        ></el-input>

        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>

      <template v-slot:slot-switch="scope" >
         <el-switch v-model="scope.item.switchOriginValue" @change="changeSwicth($event,scope.item)"></el-switch>
      </template>
    </List>

    <DeviceMonitorTemplateItemUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
      :monitorTemplateTypeList="MonitorTemplateTypeList"
      :deviceMonitorMetricsList="DeviceMonitorMetricsList"
    ></DeviceMonitorTemplateItemUpdateBox>

    <DeviceMonitorTemplateTypeUpdateBox
      :initForm="templateTypeUpdateForm"
      :updateType="templateTypeUpdateType"
      v-if="templateTypeUpdateBlock"
      @close="closeTemplateType(false)"
      @update="closeTemplateType(true)"
    ></DeviceMonitorTemplateTypeUpdateBox>

    <DeviceMonitorMetricUpdateBox
      :initForm="deviceMetricUpdateForm"
      :updateType="deviceMetricUpdateType"
      v-if="deviceMetricUpdateBlock"
      @close="closeDeviceMetric(false)"
      @update="closeDeviceMetric(true)"
    ></DeviceMonitorMetricUpdateBox>
  </div>
</template>

<script>
import { SwitchStatus } from "../components/Index/data.js";
import List from "../components/common/List.vue";
import DeviceMonitorTemplateItemUpdateBox from "../components/DeviceMonitor/DeviceMonitorTemplateItemUpdateBox.vue";
import DeviceMonitorTemplateTypeUpdateBox from "../components/DeviceMonitor/DeviceMonitorTemplateTypeUpdateBox.vue";
import DeviceMonitorMetricUpdateBox from "../components/DeviceMonitor/DeviceMonitorMetricUpdateBox.vue";

export default {
  components: {
    List,
    DeviceMonitorTemplateItemUpdateBox,
    DeviceMonitorTemplateTypeUpdateBox,
    DeviceMonitorMetricUpdateBox
  },
  data() {
    return {
      token: "",
      selectTemplateType: "全部",
      MonitorTemplateTypeList: [],
      DeviceMonitorMetricsList: [],
      selectStatus: "全部",
      switchStatus: SwitchStatus,
      dialogFormVisible: false,
      title: "设备监控-模板监控项",
      tanle: [
        { name: "template_name", label: "所属模板" },
        { name: "metric_name", label: "指标名称" },
        { name: "metric_key", label: "指标key" },
        { name: "cmd", label: "监控命令" },
        { name: "pipeline", label: "数据处理命令" },
        { name: "switch", label: "监控项是否启用" },
        { name: "desc", label: "监控项说明" }
      ],
      searchData: {
        template_name: "",
        metric_name: "",
        metric_key: "",
        cmd: "",
        status: "",
        desc: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      templateTypeUpdateForm: {},
      templateTypeUpdateType: "add",
      templateTypeUpdateBlock: false,
      deviceMetricUpdateForm: {},
      deviceMetricUpdateType: "add",
      deviceMetricUpdateBlock: false
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchDeviceMonitorTemplateTypes();
    this.fetchDeviceMonitorMetrics();
  },
  methods: {
    addTemplateType() {
      this.templateTypeUpdateType = "add";
      this.templateTypeUpdateForm = {};
      this.templateTypeUpdateBlock = true;
    },
    closeTemplateType(reloadTemplateType=true) {
      this.templateTypeUpdateBlock = false;
      if (reloadTemplateType) {
        this.fetchDeviceMonitorTemplateTypes();
      }
    },
    addDeviceMetric() {
      this.deviceMetricUpdateType = "add";
      this.deviceMetricUpdateForm = {};
      this.deviceMetricUpdateBlock = true;
    },
    closeDeviceMetric(reloadDeviceMetric=true) {
      this.deviceMetricUpdateBlock = false;
      if (reloadDeviceMetric) {
        this.fetchDeviceMonitorMetrics();
      }
    },
    fetchDeviceMonitorTemplateTypes() {
      this.$http["get"](
        "device-monitor/template-type/", {}, (data) => {
          this.MonitorTemplateTypeList = data.data.results.map(item => item.name);
          this.MonitorTemplateTypeList.unshift("全部"); // 在数组开头插入 "全部" 元素
        }
      );
    },
    fetchDeviceMonitorMetrics() {
      this.$http["get"](
        "device-monitor/metrics/", {}, (data) => {
          this.DeviceMonitorMetricsList = data.data.results.map(item => item.name);
        }
      );
    },
    openDeviceMonitorTemplateTypes() {
      let routeData = this.$router.resolve("/deviceMonitorTemplateTypes");
      window.open(routeData.href, "_blank");
    },
    openDeviceMonitorMetrics() {
      let routeData = this.$router.resolve("/deviceMonitorMetrics");
      window.open(routeData.href, "_blank");
    },
    changeSwicth(changeValue,itemData){
      var params = {
        id: itemData.id,
        template_name: itemData.template_name,
        metric_name: itemData.metric_name,
        cmd: itemData.cmd,
        status: +(changeValue),
        desc: itemData.desc
      };
      var url = "device-monitor/template-item/" + itemData.id + "/";
      this.$http["patch"](
        url,
        params,
        () => {
          this.$baseNotice.message("状态更新成功");
          this.updateList++;
        }
      );
    },
    dealList(data) {
      for (let i in data) {
        data[i].switchOriginValue = Boolean(data[i].status);
        data[i].switch = data[i].status ? "开启" : "关闭";
        data[i].create_time = this.changeDate(data[i].create_time);
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {switch: '开启'};
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateBlock = true;
    },
    search() {
      this.searchData.template_name = this.selectTemplateType === "全部" ? "" : this.selectTemplateType;
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = +(this.selectStatus === '开启');
      };
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-monitor/template-item/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
